import cookieUtils from 'utils/Cookies';

function isCCREnabled() {
    const { isCCRewardsEnabled } = Sephora.configurationSettings;
    const isRCPSProductEnabled = cookieUtils.isRCPSProductEnabled();
    const isRCPSCCEnabled = cookieUtils.isRCPSCCEnabled();

    if (isCCRewardsEnabled && isRCPSProductEnabled && isRCPSCCEnabled) {
        return true;
    }

    return false;
}

export default isCCREnabled;
